import React from "react";
import '../src/NavBar.css'
import logoBG from './assets/logoBG.png'

function NavBar({ accounts, setAccounts }) {
    const isConnected = Boolean(accounts[0])
    async function connectAccount() {
        if (window.ethereum) {
            const accounts = await window.ethereum.request({
                method: "eth_requestAccounts",
            });
            setAccounts(accounts)
        }
    }
    return <>
        <div className='NavBar pb-3'>
            {/* left side */}
            <div className='logoContainer'>
                <p className="d-none title d-lg-block col-12"><img className="logo" src={logoBG} alt="logo" /> Bored Goats</p>
                <p className="d-lg-none title">Bored <img className="logo" src={logoBG} alt="logo" /> Goats</p>
            </div>
            {/* right side */}
            <div className='sectionContainer'>
                <div className="d-lg-flex d-none">
                    <div className='px-3 text-uppercase'>
                        <a className="twitter" href="https://twitter.com/BoredGoatsNFT/">Twitter</a>
                    </div>
                    <div className='px-3 text-uppercase'>
                        <a className="opensea" href="https://opensea.io/collection/boredgoats-v">Opensea</a>
                    </div>
                </div>
                <div className="connectBtn">
                    {/* connect */}
                    {isConnected ? (<button className="d-lg-block d-none">Connected</button>) : (<>
                        <button className="d-lg-block d-none" onClick={connectAccount}>Connect</button></>
                    )}
                </div>
            </div>

        </div>
    </>
}

export default NavBar